import React from "react";

const RightArrow = ({
  className = "w-8 h-8",
  fill = "white",
}: {
  className: string;
  fill: string;
}) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3896 8.39063C16.1397 8.64066 15.9993 8.97974 15.9993 9.33329C15.9993 9.68685 16.1397 10.0259 16.3896 10.276L22.1136 16L16.3896 21.724C16.1468 21.9754 16.0124 22.3122 16.0154 22.6618C16.0185 23.0114 16.1587 23.3458 16.4059 23.5931C16.6531 23.8403 16.9875 23.9805 17.3371 23.9835C17.6867 23.9866 18.0235 23.8522 18.275 23.6093L24.9416 16.9426C25.1916 16.6926 25.332 16.3535 25.332 16C25.332 15.6464 25.1916 15.3073 24.9416 15.0573L18.275 8.39063C18.0249 8.14066 17.6859 8.00024 17.3323 8.00024C16.9788 8.00024 16.6397 8.14066 16.3896 8.39063ZM8.38965 8.39063C8.13969 8.64066 7.99927 8.97974 7.99927 9.33329C7.99927 9.68685 8.13969 10.0259 8.38965 10.276L14.1136 16L8.38965 21.724C8.14677 21.9754 8.01238 22.3122 8.01542 22.6618C8.01845 23.0114 8.15868 23.3458 8.40589 23.5931C8.6531 23.8403 8.98752 23.9805 9.33711 23.9835C9.68671 23.9866 10.0235 23.8522 10.275 23.6093L16.9416 16.9426C17.1916 16.6926 17.332 16.3535 17.332 16C17.332 15.6464 17.1916 15.3073 16.9416 15.0573L10.275 8.39063C10.0249 8.14066 9.68587 8.00024 9.33232 8.00024C8.97876 8.00024 8.63968 8.14066 8.38965 8.39063Z"
        fill={fill}
      />
    </svg>
  );
};

export default RightArrow;
